import styled from 'styled-components';

export const Title = styled.h1`
    font-size: 48px;
    font-weight: 700;
    text-align: left;
`;

export const SubTitle = styled.h2`
    font-size: 36px;
    font-weight: bold;
    text-align: left;
    color: #0085AF;
`;

